import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { addToCart } from "../../../redux/actions/cartActions";
import { addToWishlist } from "../../../redux/actions/wishlistActions";
import { addToCompare } from "../../../redux/actions/compareActions";
import ProductTeaser from "../productTeaser/ProductTeaser";
import ProductTeaserWrap from "./ProductTeaserWrap";

const ProductGrid = ({ products, currency, addToCart, addToWishlist, addToCompare, cartItems, wishlistItems, compareItems }) => {
    return (
        <Fragment>
            {products.map((product) => {
                return (
                    <div key={product["@id"]} className="col-xl-4 col-sm-6 mb-25">
                        <ProductTeaser
                            product={product}
                            currency={currency}
                            addToCart={addToCart}
                            addToWishlist={addToWishlist}
                            addToCompare={addToCompare}
                            cartItem={cartItems.filter((cartItem) => cartItem.id === product.id)[0]}
                            wishlistItem={wishlistItems.filter((wishlistItem) => wishlistItem.id === product.id)[0]}
                            compareItem={compareItems.filter((compareItem) => compareItem.id === product.id)[0]}
                        />
                        <ProductTeaserWrap
                            product={product}
                            currency={currency}
                            addToCart={addToCart}
                            addToWishlist={addToWishlist}
                            addToCompare={addToCompare}
                            cartItem={cartItems.filter((cartItem) => cartItem.id === product.id)[0]}
                            wishlistItem={wishlistItems.filter((wishlistItem) => wishlistItem.id === product.id)[0]}
                            compareItem={compareItems.filter((compareItem) => compareItem.id === product.id)[0]}
                        />
                    </div>
                );
            })}
        </Fragment>
    );
};

ProductGrid.propTypes = {
    addToCart: PropTypes.func,
    addToCompare: PropTypes.func,
    addToWishlist: PropTypes.func,
    cartItems: PropTypes.array,
    compareItems: PropTypes.array,
    currency: PropTypes.object,
    products: PropTypes.array,
    wishlistItems: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        currency: state.currencyData,
        cartItems: state.cartData,
        wishlistItems: state.wishlistData,
        compareItems: state.compareData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item, addToast, quantityCount, selectedProductColor, selectedProductSize) => {
            dispatch(addToCart(item, addToast, quantityCount, selectedProductColor, selectedProductSize));
        },
        addToWishlist: (item, addToast) => {
            dispatch(addToWishlist(item, addToast));
        },
        addToCompare: (item, addToast) => {
            dispatch(addToCompare(item, addToast));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGrid);
